import {vpost} from "@/util/post";

export const miuDemand = {
    list(pageSize, pageCurrent, examine, keyword) {
        let dto = {
            pageSize,
            pageCurrent,
            examine: examine,
            keyword
        };

        return vpost("/adminMiuDemand/list", dto);
    },


    detail(id) {
        return vpost("/adminMiuDemand/detail?id=" + id);
    },

    examine(id, code, errMsg = null) {
        let dto = {
            id,
            code,
            errMsg
        }
        return vpost("/adminMiuDemand/examine", dto);
    },

    publish(id, publish) {
        let dto = {
            id,
            publish
        };

        return vpost("/adminMiuDemand/publish", dto)
    },


}